import { useSessionStore } from '@/entities/session';
import {
  CACHE_TIME_10_MINUTES,
  CACHE_TIME_5_MINUTES,
} from '@/shared/config/caching';
import { useQuery } from '@tanstack/react-query';
import {
  getSccrsGamingHalls,
  type GetSccrsGamingHallsParams,
} from '@/entities/sccrs';

const useGetSccrsGamingHalls = (params?: GetSccrsGamingHallsParams) => {
  const { session } = useSessionStore();

  const { data, isLoading, error } = useQuery({
    queryKey: ['getSccrsGamingHalls', params],
    queryFn: () => getSccrsGamingHalls(params),
    enabled: !!session?.userId,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 0,
  });

  return {
    gamingHalls: data,
    isGamingHallsLoading: isLoading,
    gamingHallsError: error,
  };
};

export { useGetSccrsGamingHalls };
